<div class="noprint">
<hr>
 <h3 class="product-form-head">Enter Product Details</h3>
 <!-- {{ quotationService.count }} -->
<div class="form-inline">
    <div>
        <input class="form-control" placeholder="Product Name" type="text" #productName>
    </div>&nbsp;
    <div>
        <input class="form-control" placeholder="Product Description" type="text" #productDesc>
    </div>&nbsp;
    <div>
        <input class="form-control" placeholder="Product Amount" type="number" #productAmt>
    </div>&nbsp;
    <div>
        <button class="btn btn-success btn-block" (click) = "onAddProduct(productName,productDesc,productAmt)">Add Product Details</button>
    </div>
 </div>
</div>